import { render, staticRenderFns } from "./LargeWithProductImage.vue?vue&type=template&id=e1c1f83a&"
import script from "./LargeWithProductImage.vue?vue&type=script&lang=js&"
export * from "./LargeWithProductImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowButton: require('/vercel/path0/components/general/ArrowButton.vue').default,AppImage: require('/vercel/path0/components/general/AppImage.vue').default})
